import type { RouterConfig } from '@nuxt/schema'

const routerConfig: RouterConfig = {
  routes: (_routes) => {
    // Example: Remove routes starting with '/desktop' or '/mobile'
    return _routes.filter((item) => {
      return !item.path.startsWith('/desktop') && !item.path.startsWith('/mobile')
    })

    // Example: Adding a prefix to all paths
    // return _routes.map((item) => {
    //   item.path = `/:locale?${item.path}`;
    //   return item;
    // });
  },
}

// Explicitly define the base property within your main Nuxt configuration if necessary.
export const config = {
  router: {
    base: '/tdd/', // This might go in your nuxt.config.js/.ts instead.
    ...routerConfig,
  },
}

export default config
